import { HighlightCard } from "../components/HighlightCard";
import { SchoolSection } from "../components/SchoolSection";
import { SectionTitle } from "../components/SectionTitle";
import { useSchoolLocal } from "../useSchoolLocal";

type SupportArea = {
  title: string;
  tags: string;
};

export const SupportAreas = () => {
  const { t, tObject } = useSchoolLocal();

  return (
    <SchoolSection className="bg-[#F8F8F8]" contentClassName="py-14 md:py-20">
      <SectionTitle className="mb-8 text-center">
        {t("supportAreas.title")}
      </SectionTitle>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {tObject<SupportArea[]>("supportAreas.areas").map((area) => (
          <HighlightCard key={area.title} className="min-h-[120px]">
            <h3 className="mb-2 text-[15px] font-bold leading-snug group-hover:text-[#4242CE]">
              {area.title}
            </h3>
            <p className="text-xs leading-relaxed text-[#828282]">
              {area.tags}
            </p>
          </HighlightCard>
        ))}
      </div>
    </SchoolSection>
  );
};
